import React, { PropsWithChildren, useContext } from 'react'
import AppContext from '../appContext'

// Shared shell for the authentication pages (login, reset password). Renders the
// full-bleed farm photo with the branding overlay on the left and the passed-in
// card on the right. On small screens the branding collapses to just the logo and
// the card sits over a dimmed photo.
const AuthLayout: React.FC<PropsWithChildren> = ({ children }) => {
    const app = useContext(AppContext)

    return (
        <div className="relative isolate min-h-screen w-full overflow-hidden">
            {/* Background photo */}
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: 'url(/images/login-bg.jpg)' }}
                aria-hidden
            />

            <div className="relative flex min-h-screen flex-col md:flex-row">
                {/* Branding / marketing */}
                <div className="flex flex-col justify-between gap-10 p-6 pt-8 text-white md:flex-1 md:p-20">
                    <img
                        src="/images/at-logo-white.png"
                        alt="Agri Technovation"
                        className="h-10 self-start object-contain drop-shadow md:h-12"
                    />
                    <div className="hidden w-fit max-w-2xl md:block">
                        <div className="w-full text-center">
                            {/* Rotating product badges. Animated WebP with a real
                                alpha channel (black canvas keyed out), so it renders
                                solid over the photo without any blend mode. */}
                            <img
                                src="/images/technovation-badges.webp"
                                alt="Technovation"
                                className="mb-6 h-14 w-auto max-w-full"
                            />
                        </div>
                        <div className="font-display text-5xl leading-[1.35] drop-shadow-md lg:text-6xl">
                            <div className="font-normal pb-4">Plan with Intelligence.</div>
                            <div className="font-bold ">Grow with Precision.</div>
                        </div>
                        <div className="my-6 h-[10px] w-full rounded-sm bg-white/90" />
                        <div className="flex max-w-full items-center gap-2 text-lg text-white/90">
                            <span className="flex-shrink-0 whitespace-nowrap">Technovation Planner</span>
                            <span className="min-w-0 truncate rounded-md bg-primary-500 px-2 py-0.5 text-lg text-white">
                                v{app.initial.version.split("+")[0]}
                            </span>
                        </div>
                    </div>
                </div>

                {/* Card */}
                <div className="flex flex-1 items-center justify-center p-4 pb-10 md:flex-none md:p-12 md:pr-20">
                    <div className="w-full rounded-3xl bg-white px-8 py-10 shadow-2xl md:w-[28rem] md:px-10">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AuthLayout
